import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useCycles } from '@/hooks/v1';
import { toOptions } from '@/views/Bera/_components/Filter/utils';
import { useApplicationContext } from '@/context/v1/Application/context';
import { HierarchySelect } from '@/views/Bera/_components/Filter/Fields/HierarchySelect';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance, useWatch } = Form;

export function Cycle(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();
	const { organization } = useApplicationContext();

	const companyId = useWatch('company_id_filter', form);

	const {
		data: cycles,
		isLoading,
		isFetching,
		isError
	} = useCycles({
		organization_id: organization?.id,
		company_id: companyId
	});

	return (
		<Col xs={24}>
			<Form.Item name="cycle_id" label={I18n.get('Cycle')} labelCol={{ span: 24 }}>
				<HierarchySelect
					loading={isFetching}
					options={toOptions(cycles)}
					placeholder={I18n.get('Cycle')}
					disabled={isLoading || isFetching || isError || !companyId}
				/>
			</Form.Item>
		</Col>
	);
}
